import { render } from "./IconTeaser.vue?vue&type=template&id=95ab488c&ts=true"
import script from "./IconTeaser.vue?vue&type=script&lang=ts"
export * from "./IconTeaser.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__